module.exports = __webpack_public_path__ + "img/art.bed813e1.svg";